// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24V_f","productName":"Table_productName__HXDsl"};